<template>
  <div class="admin-layout">
    <app-header></app-header>
    <div class="admin-main">
      <appAside />
      <div class="admin-body">
        <router-view></router-view>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import appHeader from '../header/admin.vue';
import appFooter from '../footer/admin.vue';
import appAside from '../aside/admin.vue';
export default {
  name: 'Main',
  components: { appFooter, appHeader, appAside },
};
</script>

<style lang="scss" scoped>
.admin-layout {
  height: 100%;
  .admin-main {
    height: calc(100% - 60px);
    &::before,
    &::after {
      content: '';
      display: none;
      clear: both;
    }

    .admin-body {
      float: right;
      width: calc(100% - 240px);
      background: #f5f5f5;
      padding: 20px;
      height: 100%;
    }
  }
}
</style>
